const state = () => ({
  formId: null,
  temp: null,
  isProgressEntry: false,
  queryStringEntry: null
});

const getters = {
  getFormId(state) {
    return state.formId
  },
  getQueryString(state) {
    return state.queryStringEntry
  },
  getTemp(state) {
    return state.temp
  }
}

const actions = {
  setForm({ commit }, data) {
    commit('setFormId', data);
  },
  isProgressEntry({ commit }, data) {
    commit('setProgressEntry', data);
  },
  queryStringEntry({ commit }, data) {
    if (data.action == 'ADD') {
      commit('setTempData', data.payload);
    } else if (data.action == 'GET') {
      commit('setQueryStringEntry', data);
    } else if (data.action == 'DEL') {
      commit('delQueryStringEntry');
    }
  },
  getGenerateEntryLocalStorage({ commit }, data) {
    return localStorage.getItem("generateEntry");
  },
  setGenerateEntryLocalStorage({ commit }, data) {
    localStorage.setItem("generateEntry", data);
  },
  removeGenerateEntryLocalStorage({ commit }, data) {
    localStorage.removeItem("generateEntry");
  }
}

const mutations = {
  setFormId(state, payload) {
    state.formId = payload;
  },
  setProgressEntry(state, payload) {
    state.isProgressEntry = payload;
    if (!payload) {
      state.queryStringEntry = null
    }
  },
  setTempData(state, payload) {
    state.temp = payload;
  },
  setQueryStringEntry(state) {
    state.queryStringEntry = state.temp;
    state.temp = null
  },
  delQueryStringEntry(state) {
    state.queryStringEntry = null;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/forms.js